// extracted by mini-css-extract-plugin
var _1 = "ImageNode-module__image--ePlJK";
export { _1 as "image" }
